export * from './lib/desktop-data-access-service-inventory.module';
export * from './lib/store/service-inventory.actions';
export * from './lib/store/service-inventory.effects';
export * from './lib/store/service-inventory.reducer';
export * from './lib/store/service-inventory.model';
export * from './lib/store/service-inventory.selectors';
export * from './lib/store/service-inventory.service';
